import { injectable } from 'inversify';

import { t } from '@vk-hr-tek/core/translations';
import {
  TaskListCardProps,
  TaskListStatus,
} from '@vk-hr-tek/app-ui/TaskListCard';

import { WidgetPartitionView } from '@app/gen/dashboard';

import { modules } from '../../app/modules';

@injectable()
export class WidgetTaskListMapper {
  private processTaskListStatus(
    partition: WidgetPartitionView,
  ): TaskListStatus | null {
    if (partition?.count_urgent) return 'urgent';
    if (partition?.count_my) return 'active';
    if (partition.count_all) return 'empty';
    return null;
  }

  private processTaskListType(
    type: WidgetPartitionView['type'],
  ): Omit<TaskListCardProps, 'status' | 'count'> | null {
    const [module, side] = type.split('_');
    const label = t(`dashboard.widgets.taskList.${side}Label`);

    const typesMap: Record<
      string,
      Omit<TaskListCardProps, 'status' | 'count'>
    > = {
      events: {
        iconType: 'document',
        link: `/${side}/${modules.events.basename}`,
        title: 'Заявки',
        label,
      },
      vacation: {
        iconType: 'calendar',
        link: `/${side}/${modules.vacations.basename}`,
        title: 'Графики отпусков',
        label,
      },
      policies: {
        iconType: 'folder',
        link: `/employee/${modules.policy.basename}`,
        title: 'Корп. документы',
        label: 'Ознакомиться',
      },
    };

    return typesMap[module] || null;
  }

  processTaskListItems(partitions: WidgetPartitionView[]): TaskListCardProps[] {
    const validTypes = new Set([
      'events_company',
      'events_employee',
      'vacation_company',
      'vacation_employee',
      'policies',
    ]);

    return partitions
      .map((partition) => {
        if (!validTypes.has(partition.type)) {
          return null;
        }

        const status = this.processTaskListStatus(partition);
        const types = this.processTaskListType(partition.type);

        if (!types || !status) return null;

        return {
          status,
          ...types,
          count: partition.count_my || 0,
          totalCount: partition.count_all,
        };
      })
      .filter((partition) => !!partition);
  }
}
